<div class="card title-card mb-4">
  <div class="flex align-items-center">
    <i class="pi mr-1 title-card-icon" [class.pi-plus-circle]="mode === 'create'" [class.pi-pencil]="mode === 'edit'"></i>
    <p class="mb-0 text-3xl title">
      {{(mode == 'create' ? 'misc.creation.triggerRule' : 'misc.edition.triggerRule') | transloco | capitalize}}
    </p>
  </div>
</div>
<div class="card step-card flex flex-column">
  <form [formGroup]="triggerRuleForm" *ngIf="triggerRuleForm">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="p-2">
          <label for="name">{{'attribute.name' | transloco}} (*)</label>
        </div>
        <div class="p-2">
          <input pInputText id="name" type="text" formControlName="name" class="w-full">
        </div>
        <app-validation-errors [control]="triggerRuleForm.get('name')"></app-validation-errors>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="tenant">{{'model.tenant' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.tenant' | transloco"
            [options]="tenants"
            [filter]="true"
            (onChange)="tenantChanged($event)"
            styleClass="w-full"
            id="tenant"
            optionLabel="name"
            formControlName="tenant"
          ></p-dropdown>
        </div>
      </div>

      <div class="col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="organization">{{'model.organization' | transloco}}</label><br>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.organization' | transloco"
            [options]="organizations"
            [filter]="true"
            [showClear]="true"
            styleClass="w-full"
            id="organization"
            optionLabel="name"
            formControlName="organization"
          ></p-dropdown>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.category' | transloco}}</label>
          <i class="pi pi-question-circle ml-2 cursor-pointer" [pTooltip]="'forms.tooltips.triggers-category' | transloco" tooltipPosition="top"></i>
        </div>
        <div class="col-12 p-3">
          <p-radioButton
            [label]="'model.triggerCategories.alarm' | transloco"
            class="mr-3"
            name="category"
            value="ALARM"
            formControlName="category"
          ></p-radioButton>
          <p-radioButton
            [label]="'model.triggerCategories.warning' | transloco"
            name="category"
            value="WARNING"
            formControlName="category"
          ></p-radioButton>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.disabledRepeatedEvents' | transloco}}</label>
          <i class="pi pi-question-circle ml-2 cursor-pointer" [pTooltip]="'forms.tooltips.triggers-disabledRepeatedEvents' | transloco" tooltipPosition="top"></i>
        </div>
        <div class="col-12 p-3">
          <p-radioButton
            [label]="'common.yes' | transloco"
            class="mr-3"
            name="disabledRepeatedEvents"
            [value]="true"
            formControlName="disabledRepeatedEvents"
          ></p-radioButton>
          <p-radioButton
            [label]="'common.no' | transloco"
            name="disabledRepeatedEvents"
            [value]="false"
            formControlName="disabledRepeatedEvents"
          ></p-radioButton>
        </div>
      </div>

    </div>
    <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="type">{{'attribute.type' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.type' | transloco"
            [options]="types"
            [filter]="false"
            (onChange)="onTypeChange($event)"
            [autoDisplayFirst]="false"
            id="type"
            formControlName="type"
            styleClass="w-full"
          ></p-dropdown>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="expression">{{'attribute.value' | transloco}} (*)</label>
        </div>
        <div class="col-12" *ngIf="triggerRuleForm.get('type').value !== 'BYTE_MASK'">
          <input pInputText id="expression" type="text" formControlName="expression" class="w-full">
        </div>
        <div class="col-12" *ngIf="triggerRuleForm.get('type').value === 'BYTE_MASK'">
          <app-byte-input formControlName="expression"></app-byte-input>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.entityType' | transloco}} (*)</label>
        </div>
        <div class="col-12 p-3">
          <p-radioButton
            [label]="'model.device' | transloco"
            class="mr-3"
            name="entityType"
            value="DEVICE"
            formControlName="entityType"
          ></p-radioButton>
          <p-radioButton
            [label]="'model.asset' | transloco"
            name="entityType"
            value="ASSET"
            formControlName="entityType"
          ></p-radioButton>
        </div>
      </div>

    </div>

    <div class="grid">

      <div class="col-12">
        <div class="form-field col-12">
          <label>{{'attribute.appliedTo' | transloco}} (*)</label>
          <i
            (click)="appliedToInfoVisible = !appliedToInfoVisible"
            class="pi pi-info-circle cursor-pointer ml-2"
            style="font-size: 14px;"
          ></i>
        </div>
        <div class="col-12">
          <div *ngIf="appliedToInfoVisible then appliedToInfo"></div>
          <json-editor
            #appliedToEditor
            [options]="jsonEditorService.buildFormEditorOptions()"
            formControlName="appliedTo"
          ></json-editor>
        </div>
      </div>

    </div>

  </form>
  <div class="mt-auto">
    <div class="flex justify-content-between mt-4">
      <button
        [label]="'common.cancel' | transloco"
        [routerLink]="'/alarms/trigger-rules'"
        pButton
        class="p-button-danger"
        iconPos="right"
      ></button>
      <p-button
        *ngIf="triggerRuleForm"
        [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
        [disabled]="!triggerRuleForm.valid"
        [loading]="persistingChanges"
        (onClick)="persistTriggerRuleData()"
        styleClass="p-button-primary"
        class="mr-2"
      ></p-button>
    </div>
  </div>
</div>

<ng-template #appliedToInfo>
  <div class="border-1 border-round border-gray-300 mb-3 fadein animation-duration-200">
    <p class="px-3 pt-3 text-justify">{{'info.triggerRules.summary' | transloco}}</p>
    <p class="px-3 text-justify">{{'info.triggerRules.firstExample' | transloco}}</p>
    <pre class="bg-gray-50"><code>
    "measurementTypes": [
      "meterIndex"
    ]
    </code></pre>
    <p></p>
    <p class="px-3 text-justify">{{'info.triggerRules.secondExample' | transloco}}</p>
    <pre class="bg-gray-50"><code>
    "measurementNames": [
      "^sound.*"
    ]
    </code></pre>
  </div>
</ng-template>
